import { useNumericInput } from "@commonlibs";
import { NumericTextFieldProps } from "./NumericTextField.types";
import TextField from "../TextField/TextField";

const NumericTextField = ({ maxDecimals, ...textFieldProps }: NumericTextFieldProps) => {
    const numericInputProps = useNumericInput({ maxDecimals });

    return <TextField {...numericInputProps} {...textFieldProps} />;
};

export default NumericTextField;
